import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/ui';

function MessagePage({ code, titleKey, hintKey }: { code: string; titleKey: string; hintKey: string }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 px-4 text-center">
      <div className="text-6xl font-bold text-primary">{code}</div>
      <h1 className="text-xl font-semibold">{t(titleKey)}</h1>
      <p className="max-w-sm text-muted-foreground">{t(hintKey)}</p>
      <Link to="/">
        <Button className="mt-2">{t('common.backHome')}</Button>
      </Link>
    </div>
  );
}

export function NotFoundPage(): JSX.Element {
  return <MessagePage code="404" titleKey="errors.notFound.title" hintKey="errors.notFound.hint" />;
}
export function ForbiddenPage(): JSX.Element {
  return <MessagePage code="403" titleKey="errors.forbidden.title" hintKey="errors.forbidden.hint" />;
}
